import request from '../utils/request';

export async function vendorRegister(data) {
  return request.post('/vendor/register', data);
}

export async function vendorContactCheck(data) {
  return request.post('/vendor/checkContact/', data);
}

export async function vendorBasicCheck(data) {
  return request.post('/vendor/checkBasic/', data);
}

export async function vendorBusinessInfoCheck(data) {
  return request.post('/vendor/checkBusinessInfo/', data);
}

export async function vendorQualificationCheck(data) {
  return request.post('/vendor/checkQualification/', data);
}

export async function vendorQuerySupplyCategory() {
  return request.get('/vendor/querySupplyCategory/');
}

export async function vendorCommit(randomCode) {
  return request.post(`/vendor/commit?randomCode=${encodeURIComponent(randomCode)}`);
}

export async function vendorQuery(data) {
  return request.post('/vendor/query/', data);
}

export async function vendorPreview() {
  return request.get('/vendor/review');
}

export async function getBusinessTypes() {
  return request.get('/vendor/getBusinessTypes');
}

export async function getPrimary(businessType) {
  return request.get(`/vendor/getPrimary?businessTypes=${businessType}`);
}

export async function getSecondary(data) {
  return request.post('/vendor/getSecondary', data);
}

export async function addSupplier(data) {
  return request.post('/vendor/addSupplier2', data);
}

export async function getSupplier() {
  return request.get('/vendor/getPrimaryAndSecondary');
}

export async function deleteSupplier(data) {
  return request.post('/vendor/deleteSupplier', data);
}

export async function saveAndCheck(data) {
  return request.post('/vendor/saveAndCheck', data);
}

export async function read(data) {
  return request.post('/vendor/read', data);
}

export async function getInternationalTelCode() {
  return request.post('/vendor/getInternationalTelCode');
}
